(() => {
  const configs = [
    {
      grid: document.querySelector('[data-used-root-grid]'),
      form: document.querySelector('[data-used-root-filters]'),
      count: document.querySelector('[data-used-root-count]'),
      sort: document.querySelector('[data-used-root-sort]'),
      active: document.querySelector('[data-used-root-active]'),
      empty: document.querySelector('[data-used-root-empty]'),
      more: document.querySelector('[data-used-root-more]'),
      previewCount: document.querySelector('[data-used-root-preview-count]'),
      drawerElement: document.querySelector('#used-filter-drawer'),
      drawerTrigger: document.querySelector('[data-right-drawer-open="used-filter-drawer"]'),
      drawerBackdrop: document.querySelector('[data-right-drawer-backdrop="used-filter-drawer"]'),
      resetButtons: document.querySelectorAll('[data-used-root-reset]'),
    },
    {
      grid: document.querySelector('[data-used-brand-grid]'),
      form: document.querySelector('[data-used-brand-filters]'),
      count: document.querySelector('[data-used-brand-count]'),
      sort: document.querySelector('[data-used-brand-sort]'),
      active: document.querySelector('[data-used-brand-active]'),
      empty: document.querySelector('[data-used-brand-empty]'),
      more: document.querySelector('[data-used-brand-more]'),
      previewCount: document.querySelector('[data-used-brand-preview-count]'),
      drawerElement: document.querySelector('#used-brand-filter-drawer'),
      drawerTrigger: document.querySelector('[data-right-drawer-open="used-brand-filter-drawer"]'),
      drawerBackdrop: document.querySelector('[data-right-drawer-backdrop="used-brand-filter-drawer"]'),
      resetButtons: document.querySelectorAll('[data-used-brand-reset]'),
    },
  ];

  const config = configs.find(c => c.grid && c.form && c.drawerElement);
  if (!config) return;

  const {
    grid,
    form,
    count,
    sort,
    active,
    empty,
    more,
    previewCount,
    drawerElement,
    drawerTrigger,
    drawerBackdrop,
    resetButtons,
  } = config;

  const endpoint = grid.dataset.usedListingEndpoint || '';
  const pageSize = Number(grid.dataset.usedPageSize) || 6;
  let scope = {};
  try {
    scope = JSON.parse(grid.dataset.usedListingScope || '{}');
  } catch (_) {
    scope = {};
  }

  let filterOptions = {};
  try {
    filterOptions = JSON.parse(form.dataset.usedFilterOptions || '{}');
  } catch (_) {
    filterOptions = {};
  }

  const sortButtons = sort ? [...sort.querySelectorAll('[data-sort-key]')] : [];
  const availableFilterNames = [
    'brand',
    'model',
    'generation',
    'transmission',
    'owners',
    'body',
    'drive',
  ];
  const filterNames = availableFilterNames.filter(name => form.elements.namedItem(name));

  const sortSettings = {
    price: {
      asc: 'price-asc',
      desc: 'price-desc',
      first: 'asc',
      label: 'Цена',
      ascLabel: 'по возрастанию',
      descLabel: 'по убыванию',
    },
    year: {
      asc: 'year-asc',
      desc: 'year-desc',
      first: 'desc',
      label: 'Год',
      ascLabel: 'сначала старые',
      descLabel: 'сначала новые',
    },
    mileage: {
      asc: 'mileage-asc',
      desc: 'mileage-desc',
      first: 'asc',
      label: 'Пробег',
      ascLabel: 'сначала меньший',
      descLabel: 'сначала больший',
    },
  };
  const ownerLabels = { '1': '1 владелец', '2': '2 владельца', '3plus': '3 и более' };
  let appliedFilters = Object.fromEntries(filterNames.map(name => [name, '']));
  let sortValue = 'default';
  let offset = grid.querySelectorAll('.catalog-car--used').length;
  let total = Number(grid.dataset.usedTotal) || offset;
  let loading = false;
  let requestToken = 0;
  const lotInput = form.querySelector('[data-used-root-lot]');
  const lotClear = form.querySelector('[data-used-root-lot-clear]');
  let lotNumber = '';
  let lotTimer = 0;

  const field = name => form.elements.namedItem(name);

  const mobileFilterTrigger = document.querySelector('.mobile-filter-button');
  const filterTriggers = [drawerTrigger, mobileFilterTrigger].filter(Boolean);

  if (mobileFilterTrigger && drawerElement?.id) {
    mobileFilterTrigger.setAttribute('aria-controls', drawerElement.id);
    mobileFilterTrigger.setAttribute('aria-expanded', 'false');
    mobileFilterTrigger.setAttribute('aria-label', 'Фильтры');
  }

  const updateFilterTrigger = () => {
    const activeCount = lotNumber
      ? 1
      : Object.values(appliedFilters).filter(Boolean).length;
    const label = activeCount ? `Фильтры, применено: ${activeCount}` : 'Фильтры';
    filterTriggers.forEach(button => {
      const badge = button.querySelector('[data-used-filter-count]');
      if (badge) {
        badge.textContent = String(activeCount);
        badge.hidden = activeCount === 0;
      }
      button.setAttribute('aria-label', label);
    });
  };

  const fillOptions = (name, options, placeholder, selected = '') => {
    const select = field(name);
    if (!select) return;
    select.replaceChildren(
      new Option(placeholder, ''),
      ...options.map(({ value, label }) => new Option(label, value))
    );
    select.value = options.some(option => option.value === selected) ? selected : '';
  };

  const optionsFor = (name, { brand = '', model = '' } = {}) => {
    const list = Array.isArray(filterOptions[name]) ? filterOptions[name] : [];
    if (name === 'model') {
      return list.filter(item => !brand || item.brand === brand);
    }
    if (name === 'generation') {
      return list.filter(
        item => (!brand || item.brand === brand) && (!model || item.model === model)
      );
    }
    return list;
  };

  const syncModelOptions = () => {
    if (!field('model')) return;
    const brand = field('brand')?.value || scope.mark || '';
    fillOptions('model', optionsFor('model', { brand }), 'Все модели', field('model').value);
  };

  const syncGenerationOptions = () => {
    if (!field('generation')) return;
    const brand = field('brand')?.value || scope.mark || '';
    const model = field('model')?.value || scope.model_scope || '';
    fillOptions(
      'generation',
      optionsFor('generation', { brand, model }),
      'Все поколения',
      field('generation').value
    );
  };

  if (field('brand')) fillOptions('brand', optionsFor('brand'), 'Все марки');
  syncModelOptions();
  syncGenerationOptions();
  if (field('transmission')) {
    fillOptions('transmission', optionsFor('transmission'), 'Любая');
  }
  if (field('owners')) fillOptions('owners', optionsFor('owners'), 'Любое');
  if (field('body')) fillOptions('body', optionsFor('body'), 'Любой');
  if (field('drive')) fillOptions('drive', optionsFor('drive'), 'Любой');

  const readDraft = () => Object.fromEntries(filterNames.map(name => [name, field(name)?.value || '']));
  const writeDraft = state => {
    if (field('brand')) field('brand').value = state.brand || '';
    syncModelOptions();
    if (field('model')) field('model').value = state.model || '';
    syncGenerationOptions();
    if (field('generation')) field('generation').value = state.generation || '';
    filterNames
      .filter(name => !['brand', 'model', 'generation'].includes(name))
      .forEach(name => {
        if (field(name)) field(name).value = state[name] || '';
      });
  };

  const syncUrl = () => {
    const params = new URLSearchParams();
    Object.entries(appliedFilters).forEach(([key, value]) => {
      if (value) params.set(key, value);
    });
    if (sortValue !== 'default') params.set('sort', sortValue);
    if (lotNumber) params.set('lot', lotNumber);
    const nextUrl = new URL(location.href);
    nextUrl.search = params.toString();
    try {
      history.replaceState(null, '', nextUrl.href);
    } catch (_) {
      /* ignore */
    }
  };

  const updateSortControls = () => {
    sortButtons.forEach(button => {
      const settings = sortSettings[button.dataset.sortKey];
      if (!settings) return;
      const direction =
        sortValue === settings.asc ? 'asc' : sortValue === settings.desc ? 'desc' : '';
      const nextDirection =
        direction === 'asc' ? 'desc' : direction === 'desc' ? 'asc' : settings.first;
      button.setAttribute('aria-pressed', String(Boolean(direction)));
      button.dataset.sortDirection = direction || 'none';
      button.setAttribute(
        'aria-label',
        direction
          ? `${settings.label}: ${settings[`${direction}Label`]}. Нажмите, чтобы изменить направление`
          : `${settings.label}: сортировать ${settings[`${nextDirection}Label`]}`
      );
    });
  };

  const labelFor = (name, value) => {
    const select = field(name);
    if (!select) return value;
    const option = [...select.options].find(item => item.value === value);
    return option?.textContent || value;
  };

  const renderActive = () => {
    if (!active) return;
    if (lotNumber) {
      active.replaceChildren();
      return;
    }
    const labels = {
      brand: 'Марка',
      model: 'Модель',
      generation: 'Поколение',
      transmission: 'Трансмиссия',
      owners: 'Владельцы',
      body: 'Кузов',
      drive: 'Привод',
    };
    active.replaceChildren();
    Object.entries(appliedFilters).forEach(([name, value]) => {
      if (!value) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.clearFilter = name;
      button.textContent = `${labels[name] || name}: ${labelFor(name, value)} ×`;
      button.setAttribute(
        'aria-label',
        `Убрать фильтр: ${labels[name] || name} ${labelFor(name, value)}`
      );
      active.append(button);
    });
  };

  const enhanceCards = root => {
    window.AscUsedPricing?.syncCards?.(root);
    window.AscUsedCardGifts?.sync?.(root);
  };

  const updateUi = ({ hasMore } = {}) => {
    if (count) count.textContent = String(total);
    if (previewCount) previewCount.textContent = String(total);
    grid.hidden = total === 0;
    if (empty) empty.hidden = total !== 0;
    if (more) {
      const moreLeft = typeof hasMore === 'boolean' ? hasMore : offset < total;
      more.hidden = total === 0 || !moreLeft;
      more.disabled = loading;
    }
    renderActive();
    updateFilterTrigger();
    syncUrl();
  };

  const buildParams = ({ append = false } = {}) => {
    const params = new URLSearchParams();
    Object.entries(scope).forEach(([key, value]) => {
      if (value) params.set(key, value);
    });
    if (lotNumber) {
      params.set('lot', lotNumber);
    } else {
      Object.entries(appliedFilters).forEach(([key, value]) => {
        if (value) params.set(key, value);
      });
    }
    if (sortValue !== 'default') params.set('sort', sortValue);
    params.set('limit', String(pageSize));
    params.set('offset', String(append ? offset : 0));
    return params;
  };

  const fetchListing = async ({ append = false } = {}) => {
    if (!endpoint) return;
    const token = ++requestToken;
    loading = true;
    updateUi();
    try {
      const response = await fetch(`${endpoint}?${buildParams({ append })}`, {
        headers: { Accept: 'application/json' },
      });
      if (token !== requestToken) return;
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data = await response.json();
      total = Number(data.total) || 0;
      if (append) {
        grid.insertAdjacentHTML('beforeend', data.html || '');
      } else {
        grid.innerHTML = data.html || '';
      }
      offset = grid.querySelectorAll('.catalog-car--used').length;
      enhanceCards(grid);
      updateUi({ hasMore: Boolean(data.hasMore) });
    } catch (_) {
      if (token !== requestToken) return;
      if (more) more.hidden = false;
    } finally {
      if (token === requestToken) {
        loading = false;
        if (more) more.disabled = false;
      }
    }
  };

  const updatePreview = async () => {
    if (!previewCount || !endpoint) return;
    const draft = readDraft();
    const params = new URLSearchParams();
    Object.entries(scope).forEach(([key, value]) => {
      if (value) params.set(key, value);
    });
    if (lotNumber) {
      params.set('lot', lotNumber);
    } else {
      Object.entries(draft).forEach(([key, value]) => {
        if (value) params.set(key, value);
      });
    }
    if (sortValue !== 'default') params.set('sort', sortValue);
    params.set('limit', '1');
    params.set('offset', '0');
    try {
      const response = await fetch(`${endpoint}?${params}`, {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;
      const data = await response.json();
      previewCount.textContent = String(Number(data.total) || 0);
    } catch (_) {
      /* ignore */
    }
  };

  const resetApplied = () => {
    appliedFilters = Object.fromEntries(filterNames.map(name => [name, '']));
    sortValue = 'default';
    lotNumber = '';
    if (lotInput) lotInput.value = '';
    if (lotClear) lotClear.hidden = true;
    writeDraft(appliedFilters);
    updateSortControls();
    fetchListing({ append: false });
  };

  const drawer = window.AscRightDrawer?.create({
    drawer: drawerElement,
    triggers: filterTriggers,
    backdrop: drawerBackdrop,
    initialFocus: () =>
      lotInput ||
      field('brand') ||
      field('model') ||
      field('generation') ||
      form.querySelector('select, input, button'),
  });

  const applyLot = value => {
    lotNumber = String(value || '').replace(/[^0-9]/g, '');
    if (lotInput) lotInput.value = lotNumber;
    if (lotClear) lotClear.hidden = !lotNumber;
    fetchListing({ append: false });
    updatePreview();
  };

  if (lotInput) {
    lotInput.addEventListener('input', () => {
      lotNumber = lotInput.value.replace(/[^0-9]/g, '');
      lotInput.value = lotNumber;
      if (lotClear) lotClear.hidden = !lotNumber;
      window.clearTimeout(lotTimer);
      lotTimer = window.setTimeout(() => {
        fetchListing({ append: false });
        updatePreview();
      }, 200);
    });
  }

  lotClear?.addEventListener('click', () => {
    window.clearTimeout(lotTimer);
    applyLot('');
    lotInput?.focus();
  });

  if (drawerElement) {
    drawerElement.addEventListener('rightdrawer:beforeopen', () => {
      writeDraft(appliedFilters);
      updatePreview();
    });
  }

  field('brand')?.addEventListener('change', () => {
    syncModelOptions();
    syncGenerationOptions();
    updatePreview();
  });

  field('model')?.addEventListener('change', () => {
    syncGenerationOptions();
    updatePreview();
  });

  form.addEventListener('change', updatePreview);

  form.addEventListener('submit', event => {
    event.preventDefault();
    appliedFilters = readDraft();
    fetchListing({ append: false });
    drawer?.close();
  });

  form.addEventListener('reset', event => {
    event.preventDefault();
    writeDraft(Object.fromEntries(filterNames.map(name => [name, ''])));
    updatePreview();
  });

  if (sort) {
    sort.addEventListener('click', event => {
      const button = event.target.closest('[data-sort-key]');
      if (!button) return;
      const settings = sortSettings[button.dataset.sortKey];
      if (!settings) return;
      sortValue =
        sortValue === settings.asc
          ? settings.desc
          : sortValue === settings.desc
            ? settings.asc
            : settings[settings.first];
      updateSortControls();
      fetchListing({ append: false });
    });
  }

  if (active) {
    active.addEventListener('click', event => {
      const button = event.target.closest('[data-clear-filter]');
      if (!button) return;
      const key = button.dataset.clearFilter;
      appliedFilters[key] = '';
      if (key === 'brand') {
        appliedFilters.model = '';
        appliedFilters.generation = '';
      } else if (key === 'model') {
        appliedFilters.generation = '';
      }
      writeDraft(appliedFilters);
      fetchListing({ append: false });
    });
  }

  resetButtons.forEach(button => button.addEventListener('click', resetApplied));

  if (more) {
    more.addEventListener('click', () => {
      fetchListing({ append: true });
    });
  }

  const requested = new URLSearchParams(location.search);
  filterNames.forEach(name => {
    const value = requested.get(name);
    if (!value) return;
    if (['model', 'generation'].includes(name)) return;
    const select = field(name);
    if (select && [...select.options].some(option => option.value === value)) {
      appliedFilters[name] = value;
    }
  });

  writeDraft(appliedFilters);

  const requestedModel = requested.get('model');
  if (
    field('model') &&
    requestedModel &&
    [...field('model').options].some(option => option.value === requestedModel)
  ) {
    appliedFilters.model = requestedModel;
    writeDraft(appliedFilters);
  }

  const requestedGeneration = requested.get('generation');
  if (
    field('generation') &&
    requestedGeneration &&
    [...field('generation').options].some(option => option.value === requestedGeneration)
  ) {
    appliedFilters.generation = requestedGeneration;
    writeDraft(appliedFilters);
  }

  const requestedSort = requested.get('sort');
  const supportedSorts = new Set(
    Object.values(sortSettings).flatMap(settings => [settings.asc, settings.desc])
  );
  if (requestedSort && supportedSorts.has(requestedSort)) {
    sortValue = requestedSort;
  }

  const requestedLot = requested.get('lot');
  if (lotInput && requestedLot && /^[0-9]+$/.test(requestedLot)) {
    lotNumber = requestedLot;
    lotInput.value = requestedLot;
    if (lotClear) lotClear.hidden = false;
  }

  writeDraft(appliedFilters);
  updateSortControls();
  enhanceCards(grid);

  const hasUrlState =
    Object.values(appliedFilters).some(Boolean) || sortValue !== 'default' || lotNumber !== '';
  if (hasUrlState) {
    fetchListing({ append: false });
  } else {
    updateUi({ hasMore: offset < total });
  }
})();
